import {
  useMutation,
  useQuery,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query'
import type { AxiosResponse } from 'axios'
import type {
  AdminListUsersOutput,
  AdminListUsersParams,
  AdminUpdateUserPersonalInfoInput,
  AdminUser,
} from '../api'
import { adminListUsersOptions } from './admin-user.options'
import UserService from './admin-user.service'

export const useAdminListUsers = (
  params: Omit<AdminListUsersParams, 'userType'> & {
    userType?: 'user' | 'agent'
  },
): UseQueryResult<AxiosResponse<AdminListUsersOutput>, Error> => {
  return useQuery(adminListUsersOptions(params as AdminListUsersParams))
}

export const useAdminUpdateUserPersonalInfo = (): UseMutationResult<
  AxiosResponse<AdminUser>,
  Error,
  AdminUpdateUserPersonalInfoInput
> => {
  return useMutation({
    mutationFn: UserService.adminUpdateUserPersonalInfo,
  })
}
